export default {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHERS: 'OTHERS',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
}
